/**
 * Configuración de localización en español para PrimeNG
 */
export const PRIMENG_LOCALE_ES = {
  firstDayOfWeek: 1,
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  monthNames: [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ],
  monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  today: 'Hoy',
  clear: 'Limpiar',
  dateFormat: 'dd/mm/yy',
  weekHeader: 'Sem',
  weak: 'Débil',
  medium: 'Medio',
  strong: 'Fuerte',
  passwordPrompt: 'Ingrese una contraseña',
  emptyMessage: 'No se encontraron resultados',
  emptyFilterMessage: 'No se encontraron resultados',
  searchMessage: '{0} resultados disponibles',
  selectionMessage: '{0} elementos seleccionados',
  emptySelectionMessage: 'Ningún elemento seleccionado',
  emptySearchMessage: 'No se encontraron resultados',
  aria: {
    trueLabel: 'Verdadero',
    falseLabel: 'Falso',
    nullLabel: 'No seleccionado',
    star: '1 estrella',
    stars: '{star} estrellas',
    selectAll: 'Todos los elementos seleccionados',
    unselectAll: 'Todos los elementos deseleccionados',
    close: 'Cerrar',
    previous: 'Anterior',
    next: 'Siguiente',
    navigation: 'Navegación',
    scrollTop: 'Desplazar arriba',
    moveTop: 'Mover arriba',
    moveUp: 'Mover hacia arriba',
    moveDown: 'Mover hacia abajo',
    moveBottom: 'Mover abajo',
    moveToTarget: 'Mover al objetivo',
    moveToSource: 'Mover al origen',
    moveAllToTarget: 'Mover todo al objetivo',
    moveAllToSource: 'Mover todo al origen',
    pageLabel: '{page}',
    firstPageLabel: 'Primera página',
    lastPageLabel: 'Última página',
    nextPageLabel: 'Siguiente página',
    previousPageLabel: 'Página anterior',
    rowsPerPageLabel: 'Filas por página',
    jumpToPageDropdownLabel: 'Ir al menú desplegable de páginas',
    jumpToPageInputLabel: 'Ir a la entrada de página',
    selectRow: 'Fila seleccionada',
    unselectRow: 'Fila no seleccionada',
    expandRow: 'Fila expandida',
    collapseRow: 'Fila contraída',
    showFilterMenu: 'Mostrar menú de filtros',
    hideFilterMenu: 'Ocultar menú de filtros',
    filterOperator: 'Operador de filtro',
    filterConstraint: 'Restricción de filtro',
    editRow: 'Editar fila',
    saveEdit: 'Guardar edición',
    cancelEdit: 'Cancelar edición',
    listView: 'Vista de lista',
    gridView: 'Vista de cuadrícula',
    slide: 'Deslizar',
    slideNumber: '{slideNumber}',
    zoomImage: 'Ampliar imagen',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    rotateRight: 'Rotar a la derecha',
    rotateLeft: 'Rotar a la izquierda'
  }
};

